import alertShow from '../alert/alertShow';

const productPageRemoveFromCart = () => {
    const removeButton = document.getElementById('removeProductFromCart');

    if (removeButton) {
        removeButton.addEventListener('click', (e) => {
            e.preventDefault();

            const url = 'index.php?route=checkout/cart/remove';
            let keys = removeButton.dataset.cartIds;
            keys = keys.split(',');

            keys.forEach((k) => {
                const data = new FormData();
                data.append('key', k)
                fetch(url, {
                    method: 'POST',
                    body: data
                }).then((response) => {
                    if (!response.ok) {
                        throw new Error('Error occurred!')
                    }
                    return response.json();
                }).then((data) => {
                    console.log(data);
                    if (data.success) {
                        alertShow('success', 'Товар удалён из корзины!');
                        document.getElementById('thisProductInCart').classList.add('--Is-hidden');
                    }
                }).catch((err) => {
                    console.log(err);
                });
            });
        });
    }
}

export default productPageRemoveFromCart;
